import { Child } from 'pym.js';
import meta from './data/meta.json';
import Zion from './utils/Zion';

// styles
import './styles/index.scss';
import './styles/graphic.scss';

const pkg = require('../package.json');

let ai2html = null;
let animationStarted = false;

if (process.env.NODE_ENV === 'development') {
  ai2html = require('./ai2html-graphic.html');
}

window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

console.clear();

window.onload = function () {
  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;

  if (pymChild) {
    pymChild.sendHeight();
  }

  if (window.pymChild && window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, window.pymChild.parentUrl.split('?')[0]);
  }
};

function isVisible(el) {
  if (!el || !el.isConnected) return false;

  const style = window.getComputedStyle(el);
  if (style.display === 'none' || style.visibility === 'hidden') return false;

  const rect = el.getBoundingClientRect();
  return rect.width > 0 && rect.height > 0;
}

function isMobile() {
  return window.innerWidth <= 500;
}

function getArrowShape() {
  if (isMobile()) {
    return 'M0,-5 L10,0 L0,5 Z';
  }

  return 'M0,-4 L9,0 L0,4 Z';
}

function getActiveArtboard() {
  const artboards = document.querySelectorAll('#g-ai2html-graphic-box .g-artboard');

  for (let i = 0; i < artboards.length; i += 1) {
    if (isVisible(artboards[i])) return artboards[i];
  }

  return null;
}

function safeTotalLength(route) {
  try {
    return route.getTotalLength();
  } catch (e) {
    return null;
  }
}

function safePointAtLength(route, len) {
  try {
    return route.getPointAtLength(len);
  } catch (e) {
    return null;
  }
}

function clearArrows(svg) {
  const arrows = svg.querySelectorAll('.route1-direction-arrow, .route2-direction-arrow');

  arrows.forEach((el) => {
    el.remove();
  });
}

function startArrowAnimation() {
  if (animationStarted) return;
  animationStarted = true;

  const spacing = 24;
  const speed1 = 0.12;
  const speed2 = 0.12;
  const startOffset = 8;
  const endOffset = 8;

  let offset1 = 0;
  let offset2 = 0;

  function drawArrows(svg, route, offset, arrowClass, reverseDirection) {
    if (!route || !isVisible(route)) return;

    const total = safeTotalLength(route);
    if (!total || total <= startOffset + endOffset) return;

    const color = route.getAttribute('stroke') || '#dd7257';

    for (let d = startOffset + offset; d < total - endOffset; d += spacing) {
      if (d <= 1 || d >= total - 1) continue;

      let p1;
      let p0;

      if (reverseDirection) {
        p1 = safePointAtLength(route, d);
        p0 = safePointAtLength(route, Math.min(total, d + 1));
      } else {
        p1 = safePointAtLength(route, d);
        p0 = safePointAtLength(route, Math.max(0, d - 1));
      }

      if (!p1 || !p0) continue;

      const angle = Math.atan2(p1.y - p0.y, p1.x - p0.x) * 180 / Math.PI;

      const arrow = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      arrow.setAttribute('d', getArrowShape());
      arrow.setAttribute('fill', color);
      arrow.setAttribute('stroke', 'none');
      arrow.setAttribute('opacity', isMobile() ? '0.8' : '0.65');
      arrow.setAttribute('class', arrowClass);
      arrow.setAttribute('transform', `translate(${p1.x},${p1.y}) rotate(${angle})`);

      svg.appendChild(arrow);
    }
  }

  function animate() {
    const artboard = getActiveArtboard();

    if (!artboard) {
      requestAnimationFrame(animate);
      return;
    }

    const svg = artboard.querySelector('svg');

    if (!svg || !isVisible(svg)) {
      requestAnimationFrame(animate);
      return;
    }

    const route1 = svg.querySelector('#route');
    const route2 = svg.querySelector('#route-2');

    clearArrows(svg);

    offset1 += speed1;
    if (offset1 >= spacing) offset1 = 0;

    offset2 -= speed2;
    if (offset2 <= -spacing) offset2 = 0;

    drawArrows(svg, route1, offset1, 'route1-direction-arrow', false);
    drawArrows(svg, route2, offset2, 'route2-direction-arrow', true);

    if (window.pymChild) {
      window.pymChild.sendHeight();
    }

    requestAnimationFrame(animate);
  }

  animate();
}

function draw() {
  if (process.env.NODE_ENV === 'development') {
    const figure = document.querySelector('#ai2html-graphic');

    if (figure) {
      figure.innerHTML = ai2html;
    }
  }

  startArrowAnimation();

  if (window.pymChild) {
    window.pymChild.sendHeight();
  }
}
